import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EstimateRoutingModule } from './estimate-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, EstimateRoutingModule]
})
export class EstimateModule {}
